import React from 'react'
import Pt from 'prop-types'

export default function Error({ error }) {
  return (
    <section className="container">
      <h1>An error has occurred.</h1>

      <p>{error ? error.toString() : <span>An internal error has occurred. We are sorry. Please contact us at <a
        href="https://www.infinite.net.au/contact/">https://www.infinite.net.au/contact/</a> for help.</span>}</p>
    </section>
  )
}

Error.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  error: Pt.any,
}



// WEBPACK FOOTER //
// ./src/components/Error.jsx